import React from "react";
import { motion } from "framer-motion";
import { Share2 } from "lucide-react";
import SocialShare from "@/components/SocialShare";

const SharePage = () => {
  return (
    <div className="min-h-screen bg-zinc-950 p-4 md:p-6 lg:p-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-2xl mx-auto space-y-6"
      >
        {/* Header */}
        <div>
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 bg-pink-500/20 border border-pink-500/30 flex items-center justify-center rounded-sm">
              <Share2 className="w-5 h-5 text-pink-500" />
            </div>
            <div>
              <h1 className="text-3xl font-heading font-black text-white uppercase tracking-tight">
                Share Progress
              </h1>
              <p className="text-zinc-500 text-sm">Create shareable cards of your achievements</p>
            </div>
          </div>
        </div>

        {/* Social Share Component */}
        <SocialShare />
      </motion.div>
    </div>
  );
};

export default SharePage;
